import script from "./ProyectosFrontend.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProyectosFrontend.vue?vue&type=script&setup=true&lang=ts"

import "./ProyectosFrontend.vue?vue&type=style&index=0&id=efd18158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd18158"]])

export default __exports__